import { Component } from "react";
import * as React from "react";
import { MenuItem } from "./MenuItem";

export class Footer extends Component {
    public render() {
        return (
            <div style={{ background: "#050505" }}>
                <div className="top-bar-left">
                    <ul className="menu">
                        <MenuItem color="white" href="/impressum">Impressum &amp; Datenschutz</MenuItem>
                        {/* <MenuItem color="white" href="/contact">Kontakt</MenuItem> */}
                    </ul>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/navigation/Footer.tsx